<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>学习专栏视频</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.videotype" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in learnvideoList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
             </el-select>
            </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.title" @keyup.enter.native="clicksearch" placeholder="请输入新闻标题" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="编号" min-width="5%"></el-table-column>
          <el-table-column prop="Videotypes" label="视频类型" min-width="10%"></el-table-column>
          <el-table-column prop="Title" label="新闻标题" min-width="15%"></el-table-column>
          <el-table-column prop="Length" label="视频时长" min-width="5%"></el-table-column>
          <el-table-column prop="Num" label="观看次数" min-width="5%"></el-table-column>
          <el-table-column prop="Fromname" label="来源名称" min-width="8%"></el-table-column>
          <el-table-column prop="Url" label="视频网址" min-width="30%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="12%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="视频类型">
            <el-select v-model="addData.videotype" placeholder="请选择" class="select">
              <el-option
                v-for="item in learnvideoList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频标题" class="addAdminForm">
            <el-input v-model="addData.title" placeholder="请输入视频标题"></el-input>
          </el-form-item>
          <el-form-item label="视频封面" class="addAdminForm">
            <el-input v-model="addData.cover" placeholder="请输入视频封面"></el-input>
          </el-form-item>
          <el-form-item label="视频轮播图" class="addAdminForm">
            <el-input v-model="addData.pic" placeholder="请输入视频轮播图"></el-input>
          </el-form-item>
          <el-form-item label="视频时长" class="addAdminForm">
            <el-input v-model="addData.length" placeholder="请输入视频时长,单位秒"></el-input>
          </el-form-item>
          <el-form-item label="来源图标" class="addAdminForm">
            <el-input v-model="addData.fromlogo" placeholder="请输入来源图标"></el-input>
          </el-form-item>
          <el-form-item label="来源名称" class="addAdminForm">
            <el-input v-model="addData.fromname" placeholder="请输入来源名称"></el-input>
          </el-form-item>
          <el-form-item label="视频网址" class="addAdminForm">
            <el-input v-model="addData.url" placeholder="请输入视频网址"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteLearnVideoEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteLearnVideoEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteLearnVideoEdit from '@/componentsKgjt/KgjtWebsiteLearnVideoEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteLearnVideoEdit
  },
  name: 'MyKgjtWebsiteLearnVideo',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      learnvideoList: [],
      // 查询客户
      keywords: {
        videotype: '0',
        title: ''
      },
      // 添加
      addData: {
        videotype: '',
        title: '',
        cover: '',
        pic: '',
        length: '',
        fromlogo: '',
        fromname: '',
        url: ''
      }
    }
  },
  mounted () {
    this.addData.fromlogo = Vue.prototype.global.Gv_FromLogo
    this.addData.fromname = Vue.prototype.global.Gv_FromName
    this.learnvideoList = Vue.prototype.FunGetLearnVideo()
    this.GetKgjtWebsiteLearnVideoNum()
    this.GetKgjtWebsiteLearnVideoList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteLearnVideoList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteLearnVideoList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteLearnVideoNum()
      this.GetKgjtWebsiteLearnVideoList()
    },
    clickadd () {
      this.AddKgjtWebsiteLearnVideo()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteLearnVideo(row)
      })
    },
    // 产品特点
    goPic (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    GetKgjtWebsiteLearnVideoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        videotype: that.keywords.videotype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteLearnVideoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteLearnVideoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        videotype: that.keywords.videotype,
        title: that.keywords.title
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteLearnVideoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteLearnVideo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        videotype: that.addData.videotype,
        title: that.addData.title,
        cover: that.addData.cover,
        pic: that.addData.pic,
        length: that.addData.length,
        fromlogo: that.addData.fromlogo,
        fromname: that.addData.fromname,
        url: that.addData.url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteLearnVideo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.videotype = ''
            that.addData.title = ''
            that.addData.cover = ''
            that.addData.pic = ''
            that.addData.length = ''
            that.addData.fromlogo = Vue.prototype.global.Gv_FromLogo
            that.addData.fromname = Vue.prototype.global.Gv_FromName
            that.addData.url = ''

            that.GetKgjtWebsiteLearnVideoNum()
            that.GetKgjtWebsiteLearnVideoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteLearnVideo: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteLearnVideo, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteLearnVideoNum()
          that.GetKgjtWebsiteLearnVideoList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
